module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/success.31c4a0c2.svg";